import React from "react";
import { MenuBar } from "../Menubar/Menubar";
import fotoClinica1 from "../../Resources/fotoClinica1.jpg";
import fotoClinica1Webp from "../../Resources/fotoClinica1.webp";
import fotoClinica1WebpSm from "../../Resources/fotoClinica1-640.webp";
import fotoClinica2 from "../../Resources/fotoClinica2.jpg";
import fotoClinica2Webp from "../../Resources/fotoClinica2.webp";
import fotoClinica2WebpSm from "../../Resources/fotoClinica2-640.webp";

import "./Index.scss";
import { Footer } from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/LanguageContext";
import { PageMeta } from "../../components/PageMeta";
import { LocalBusinessJsonLd } from "../../components/JsonLd";

export const Index = () => {
  const { t } = useI18n();

  return (
    <div className="app">
      <div className="ini">
      <MenuBar />
      <PageMeta title={t("meta.homeTitle")} description={t("meta.description")} />
      <LocalBusinessJsonLd />
      <main id="contenido-principal" className="index">
        <section className="index__hero" aria-labelledby="index-titulo">
          <div className="index__titulo">
            <h1 id="index-titulo">{t("index.title")}</h1>
            <div className="index__heroCtas">
              <Link className="index__btn index__btn--primary" to="/cita">
                {t("index.book")}
              </Link>
              <Link className="index__btn index__btn--ghost" to="/servicios">
                {t("index.services")}
              </Link>
            </div>
          </div>
        </section>

        <section className="index__margen__info" aria-labelledby="index-profesional">
          <div className="index__card index__info">
            <div className="index__info__texto">
              <h2 id="index-profesional">Cristina Vila Portela</h2>
              <p className="index__badge" role="status">
                {t("index.colegiada")}
              </p>
            </div>
            <div className="index__media">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${fotoClinica2WebpSm} 640w, ${fotoClinica2Webp} 1040w`}
                  sizes="(max-width: 720px) 100vw, 520px"
                />
                <img
                  src={fotoClinica2}
                  alt={t("index.photoClinic")}
                  width={666}
                  height={444}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </div>
          </div>
        </section>

        <section className="index__margen__horario" aria-labelledby="index-horario">
          <div className="index__card index__horario">
            <div className="index__media">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`${fotoClinica1WebpSm} 640w, ${fotoClinica1Webp} 1040w`}
                  sizes="(max-width: 720px) 100vw, 520px"
                />
                <img
                  src={fotoClinica1}
                  alt={t("index.photoCare")}
                  width={666}
                  height={444}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </div>
            <div className="index__horario__panel">
              <header className="index__horarioIntro">
                <h2 id="index-horario">{t("index.hours")}</h2>
                <p className="index__horarioIntroLead">{t("index.hoursLead")}</p>
              </header>

              <div className="index__schedule" role="list">
                <div className="index__scheduleBlock" role="listitem">
                  <p className="index__scheduleDays">{t("index.monThu")}</p>
                  <div className="index__scheduleLines">
                    <p>
                      <span className="index__scheduleLabel">{t("index.morning")}</span>
                      <span className="index__scheduleRange">10:00 – 14:00</span>
                    </p>
                    <p>
                      <span className="index__scheduleLabel">{t("index.afternoon")}</span>
                      <span className="index__scheduleRange">16:00 – 20:00</span>
                    </p>
                  </div>
                </div>
                <div className="index__scheduleBlock" role="listitem">
                  <p className="index__scheduleDays">{t("index.friday")}</p>
                  <div className="index__scheduleLines">
                    <p>
                      <span className="index__scheduleLabel">{t("index.morning")}</span>
                      <span className="index__scheduleRange">10:00 – 15:00</span>
                    </p>
                    <p className="index__scheduleLine--off">
                      <span className="index__scheduleLabel">{t("index.afternoon")}</span>
                      <span className="index__scheduleOff">{t("index.closed")}</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="index__horarioFooter">
                <Link className="index__horarioCta" to="/cita">
                  {t("index.bookOnline")}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      </div>
    </div>
  );
};
